<template>
    <MuiWrapperWithShapes
        v-if="hasImage"
        class="mui-c-image-wrapper-with-shapes"
        :class="{'mui-c-image-wrapper-with-shapes--multiple': hasMultipleImages}"
        :enable-full-screen="props.enableFullScreen"
        :enable-scale-on-hover="props.enableFullScreen"
        :theme="props.theme"
    >
        <NuxtImg v-if="image1Url" :src="image1Url" class="mui-c-image-wrapper-with-shapes__image mui-c-image-wrapper-with-shapes__image--first" />
        <NuxtImg v-if="image2Url" :src="image2Url" class="mui-c-image-wrapper-with-shapes__image mui-c-image-wrapper-with-shapes__image--second" />
        <template #fullscreen>
            <NuxtImg v-if="image1Url" :src="image1Url" />
            <NuxtImg v-if="image2Url" :src="image2Url" />
        </template>
    </MuiWrapperWithShapes>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import MuiWrapperWithShapes from './WrapperWithShapes.vue';
    import type {MuiTheme} from '../../types/theme';

    const props = defineProps<{
        image1Url?: string;
        image2Url?: string;
        enableFullScreen?: boolean;
        theme?: MuiTheme;
    }>();

    const hasImage = computed((): boolean => !!props.image1Url || !!props.image2Url);
    const hasMultipleImages = computed((): boolean => !!props.image1Url && !!props.image2Url);
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .mui-c-image-wrapper-with-shapes {
        &--multiple {
            .mui-c-image-wrapper-with-shapes__image {
                max-width: calc(100% - var(--joy-core-spacing-2));
                max-height: calc(100% - var(--joy-core-spacing-2));
                border-radius: var(--joy-core-radius-3);

                object-fit: cover;

                position: absolute;
                bottom: var(--joy-core-spacing-4);
                right: 50%;

                &--first {
                    transform: translate(calc(50% + var(--joy-core-spacing-2)), calc(var(--joy-core-spacing-2) * -1));
                }
                &--second {
                    transform: translate(calc(50% - var(--joy-core-spacing-2)), var(--joy-core-spacing-6));
                }

                @include mq.screen_xxs(min) {
                    bottom: 0;
                    max-width: 75%;
                    max-height: calc(100% - var(--joy-core-spacing-6));

                    &--first {
                        transform: translate(calc(50% + var(--joy-core-spacing-10)), calc(var(--joy-core-spacing-2) * -1));
                    }

                    &--second {
                        transform: translate(calc(50% - var(--joy-core-spacing-10)), var(--joy-core-spacing-6));
                    }
                }

                @include mq.screen_sm(min) {
                    bottom: auto;
                    top: 50%;
                    right: 50%;
                    left: auto;
                    &--first {
                        transform: translate(calc(50% + var(--joy-core-spacing-12)), calc(-50% - var(--joy-core-spacing-4)));
                    }
                    &--second {
                        transform: translate(calc(50% - var(--joy-core-spacing-12)), calc(-50% + var(--joy-core-spacing-8)));
                    }
                }
            }
        }
    }
</style>
